export default __webpack_public_path__ + "static/media/hotspot-blue.f38fb006.svg";